export const GROUPS_QUERY_KEYS = {
  all: ["groups"] as const,
  groupsList: (entityId: number | null | undefined) => [...GROUPS_QUERY_KEYS.all, "list", entityId] as const,
  groupDetails: (groupId: number) => [...GROUPS_QUERY_KEYS.all, "detail", groupId] as const,
  mutations: {
    create: (entityId: number) => [...GROUPS_QUERY_KEYS.all, "create", entityId] as const,
  },
};
